import React from 'react';


export default (BaseComponent) => {
  const displayName =
    BaseComponent.displayName || BaseComponent.name || 'Component';

  function withReduxStoreFromWindowObject(props) {
    return <BaseComponent {...props} store={window.appState} />;
  }

  withReduxStoreFromWindowObject.displayName = `withReduxStoreFromWindowObject(${displayName})`;

  return withReduxStoreFromWindowObject;
};
